<gl-header-shopping-cart-countdown-timer></gl-header-shopping-cart-countdown-timer>

<ng-container *ngIf="env.USE_TAILWIND">
    <gl-header-stw
        [languages]="languages"
        [selected]="selected"
        [isContrast]="highContrast$ | async"
        [mobileMenuOpen]="isMenuOpen()"
        (languageChange)="handleLanguageChange($event)"
        (mobileMenuToggle)="toggleMobileMenu()"
        (mobileMenuClose)="closeMobileMenu()"
        (themeToggle)="toggleTheme()">
    </gl-header-stw>
</ng-container>

<ng-container *ngIf="!env.USE_TAILWIND">
    <gl-header-template
        *ngIf="!isLandingPage"
        [languages]="languages"
        [selected]="selected"
        [loggedInCustomer]="loggedInCustomer"
        [mobileMenuOpen]="isMenuOpen()"
        (onToggleMobileMenu)="toggleMobileMenu()"
        (onCloseMobileMenu)="closeMobileMenu()"
        (requestLanguageChange)="handleLanguageChange($event)"></gl-header-template>

    <gl-header-landing-template-gl
        *ngIf="isLandingPage && env.THEME_NAME !== themeFeature.VL"
        [languages]="languages"
        [selected]="selected"
        [loggedInCustomer]="loggedInCustomer"
        [mobileMenuOpen]="isMenuOpen()"
        (onToggleMobileMenu)="toggleMobileMenu()"
        (onCloseMobileMenu)="closeMobileMenu()"
        (requestLanguageChange)="handleLanguageChange($event)"></gl-header-landing-template-gl>

    <gl-header-landing-template-vl
        *ngIf="isLandingPage && env.THEME_NAME === themeFeature.VL"
        [languages]="languages"
        [selected]="selected"
        [loggedInCustomer]="loggedInCustomer"
        [mobileMenuOpen]="isMenuOpen()"
        (onToggleMobileMenu)="toggleMobileMenu()"
        (onCloseMobileMenu)="closeMobileMenu()"
        (requestLanguageChange)="handleLanguageChange($event)">
    </gl-header-landing-template-vl>
</ng-container>
